module.exports = __webpack_public_path__ + "img/icon_noTag.c8e52290.svg";